import { mutateApi } from "src/utils/api/ApiMethods"

export const updateReservationSettings = ({ marinaSlug, data }) => {
  return mutateApi({
    url: `/manage/${marinaSlug}/settings/reservation_settings`,
    method: "PUT",
    data,
  })
}
